import { combineReducers } from 'redux';
import { auth } from './auth';
import { error } from './error';
import { ongoingActions } from './ongoingActions';
import { currentMenuItem } from './currentMenuItem';
import { StoreState } from '../store';

export default combineReducers<StoreState>({
    auth,
    ongoingActions,
    error,
    currentMenuItem
});



// WEBPACK FOOTER //
// ./src/reducers/index.ts